import { Box } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import {
  CUSTOM_BUTTON_SIZE,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
} from 'src/components/CustomButton';

import { Actions } from './components/Actions';
import { Attachments } from './components/Attachments';
import { Instructions } from './components/Instructions';
import { Variables } from './components/Variables';
import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  isSuggestPromptLoading: PropTypes.bool,
  hideActions: PropTypes.bool,
  index: PropTypes.number,
  showImprovePrompt: PropTypes.bool,
  showSaveButtonIconOnly: PropTypes.bool,
  improvePromptTooltip: PropTypes.string,
  improvePromptCaption: PropTypes.string,
  isSlim: PropTypes.bool,
  attachedResources: PropTypes.arrayOf(PropTypes.shape()),
  onAction: PropTypes.func.isRequired,
  variables: PropTypes.arrayOf(PropTypes.shape()),
  hideAttachments: PropTypes.bool,
  showVariables: PropTypes.bool,
  onAddClick: PropTypes.func,
  showAddButton: PropTypes.bool,
  instructions: PropTypes.arrayOf(PropTypes.object),
  showInstructions: PropTypes.bool,
  footerActionsSlot: PropTypes.node,
  isEmpty: PropTypes.bool,
};

const defaultProps = {
  className: '',
  isSuggestPromptLoading: false,
  hideActions: false,
  index: 0,
  showImprovePrompt: false,
  showSaveButtonIconOnly: false,
  improvePromptTooltip: null,
  improvePromptCaption: null,
  isSlim: false,
  attachedResources: [],
  variables: [],
  hideAttachments: false,
  showVariables: false,
  onAddClick: null,
  showAddButton: false,
  instructions: [],
  showInstructions: false,
  footerActionsSlot: null,
  isEmpty: false,
};

export const Footer = ({
  className,
  isSuggestPromptLoading,
  hideActions,
  index,
  showImprovePrompt,
  showSaveButtonIconOnly,
  isSlim,
  attachedResources,
  onAction,
  variables,
  hideAttachments,
  showVariables,
  onAddClick,
  showAddButton,
  instructions,
  showInstructions,
  footerActionsSlot,
  isEmpty,
  improvePromptTooltip,
  improvePromptCaption,
}) => {
  const styles = useStyles();

  const attachmentsVisible = !hideAttachments && attachedResources.length > 0;
  const variablesVisible = showVariables && variables.length > 0;

  const contentVisible =
    attachmentsVisible || variablesVisible || showAddButton || footerActionsSlot;
  const actionsVisible = !hideActions;

  if (!contentVisible && !actionsVisible && !showInstructions) {
    return null;
  }

  return (
    <div className={cx(styles.root, className)}>
      {contentVisible && (
        <div className={styles.attachmentsWrapper}>
          {variablesVisible && (
            <Variables
              className={styles.variables}
              variables={variables}
              onAction={onAction}
            />
          )}

          {attachmentsVisible && (
            <Attachments
              className={styles.attachments}
              resources={attachedResources}
              index={index}
              onAction={onAction}
              isSlim={isSlim}
            />
          )}

          {showAddButton && (
            <CustomButton
              className={styles.buttonAdd}
              size={CUSTOM_BUTTON_SIZE.smaller}
              variant={CUSTOM_BUTTON_VARIANT.outlined}
              onClick={onAddClick}
            >
              + Add
            </CustomButton>
          )}

          {footerActionsSlot && (
            <>
              <Box flex={1} />
              {footerActionsSlot}
            </>
          )}
        </div>
      )}

      {actionsVisible && (
        <Actions
          className={styles.actions}
          onAction={onAction}
          isSuggestPromptLoading={isSuggestPromptLoading}
          showImprovePrompt={showImprovePrompt}
          showSaveButtonIconOnly={showSaveButtonIconOnly}
          improvePromptTooltip={improvePromptTooltip}
          improvePromptCaption={improvePromptCaption}
          isEmpty={isEmpty}
        />
      )}

      {showInstructions && (
        <Instructions
          className={styles.instructions}
          instructions={instructions}
          onAction={onAction}
        />
      )}
    </div>
  );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;
